import { render, staticRenderFns } from "./LocationCrud.vue?vue&type=template&id=4be4a406"
import script from "./LocationCrud.vue?vue&type=script&lang=js"
export * from "./LocationCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports